import React from "react";
import { FORM_ERROR } from "final-form";
import { useIntl } from "react-intl";

import useTrashablePromises from "hooks/useTrashablePromises";
import translateError from "utils/translateError";
import useGlobalContext from "hooks/globalData";
import {
  ProductVersion,
  ISaveProductVersion,
  SaveProductVersion,
  SaveResponse,
} from "services/KnowfullyAdminClient";

import ProductVersionForm from "./ProductVersionForm";

type ProductVersionUpdateFormProps = {
  productVersion: ProductVersion;
  onProductVersionUpdated: (id: string) => void;
  onCancel: () => void;
};

const ProductVersionUpdateForm = ({
  productVersion,
  onProductVersionUpdated,
  onCancel,
}: ProductVersionUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { productService } = useGlobalContext();

  const onSubmit = (values: ISaveProductVersion) => {
    return registerPromise(
      productService.saveProductVersion(
        new SaveProductVersion({ id: productVersion.id, ...values })
      )
    )
      .then(({ id }: SaveResponse) => {
        onProductVersionUpdated(id!);
      })
      .catch((err: any) => {
        console.log(err);
        return { [FORM_ERROR]: translateError(err, t) };
      });
  };

  return (
    <ProductVersionForm
      productVersion={productVersion}
      onSubmit={onSubmit}
      submitLabel={t({ id: "productVersionUpdateButton" })}
      onCancel={onCancel}
    />
  );
};

export default ProductVersionUpdateForm;
